import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  {
    path: '/candidate/list',
    title: 'Candidates',
    icon: 'mdi mdi-account-multiple-outline',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },
  {
    path: '/candidate/create',
    title: 'Create',
    icon: 'mdi mdi-account-multiple-plus',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },
  {
    path: '/clients/list',
    title: 'Clients',
    icon: 'mdi mdi-account-switch',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },
  {
    path: '/clients/operation-branches',
    title: 'Operation Branches',
    icon: 'mdi mdi-monitor-multiple',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },
  //login history
  {
    path: '/clients/loginHistory',
    title: 'Login History',
    icon: 'mdi mdi-login',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },

  //Downloaded activity
  {
    path: '/clients/downloadedActivity',
    title: 'Downloaded Activity ',
    icon: 'mdi mdi-download',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: true,
  },

  //Users
  {
    path: '/clients/users',
    title: 'Users',
    icon: 'mdi mdi-account-multiple',
    class: '',
    label: '',
    labelClass: '',
    extralink: false,
    submenu: [],
    toDisplay: localStorage.getItem('email') == 'marshalla.schile@gttsi.com',
  },
];
